import {
  DisbursementAction,
  DisbursementType,
  IDisbursementState,
} from "../types/disbursementTypes";

const initialState = {
  data: null,
  isLoading: false,
  error: null,
  dataDetail: null,
  isLoadingDetail: false,
  dataExport: null,
  isLoadingExport: false,
  isLoadingDDl: false,
  isLoadingCreate: false,
  isLoadingDelete: false,
  isLoadingApproval: false,
  dataTemplate: null,
  isLoadingTemplate: false,
  isLoadingCategory: false,
  dataCategories: null,
  isLoadingUpload: false,
  dataUpload: null,
  dataClient: null,
  isLoadingClient: false,
  isLoadingUserDisburse: false,
  dataUser: null,
};

export default (
  state: IDisbursementState = initialState,
  { type, payload }: DisbursementAction
) => {
  switch (type) {
    case DisbursementType.DISBURSEMENT_PENDING:
      return { ...state, ...payload, error: null };
    case DisbursementType.DISBURSEMENT_SUCCESS:
      return { ...state, ...payload };
    case DisbursementType.DISBURSEMENT_ERROR:
      return {
        ...state,
        ...payload,
      };

    default:
      return state;
  }
};
